import type { StreamChat as StreamChatClient } from 'stream-chat'

type StreamChatClass = typeof StreamChatClient

let streamChatClassPromise: Promise<StreamChatClass> | null = null

/**
 * Client-only Stream Chat SDK loader with CJS/ESM interop.
 * Apps should exclude `stream-chat` from Vite optimizeDeps and alias its
 * Node-oriented deps to browser shims (`src/utils/stream-chat/*-browser.ts`).
 */
export async function loadStreamChatSdk (): Promise<StreamChatClass> {
  streamChatClassPromise ??= import('stream-chat').then((mod) => {
    const StreamChat = mod.StreamChat ?? (mod as { default?: { StreamChat?: StreamChatClass } }).default?.StreamChat

    if (!StreamChat) {
      throw new Error('StreamChat export not found in stream-chat package')
    }

    return StreamChat
  })

  return streamChatClassPromise
}
